import React from "react";

export default function MoreOptions({ color = "#616161", ...restProps }) {
  return (
    <svg
      id="more_options_icon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={6}
      height={25}
      viewBox="0 0 6 25"
      {...restProps}
    >
      <defs>
        <path id="z" d="M0 .958h5.452v5.453H0z" />
        <path id="y" d="M0 .547h5.452V6H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 .042)">
          <mask id="u" fill="#fff">
            <use xlinkHref="#z" />
          </mask>
          <path
            fill={color}
            d="M5.452 3.684a2.726 2.726 0 1 1-5.453.001 2.726 2.726 0 0 1 5.453-.001"
            mask="url(#u)"
          />
        </g>
        <path
          fill={color}
          d="M5.452 12.52a2.726 2.726 0 1 1-5.453.002 2.726 2.726 0 0 1 5.453-.002"
        />
        <g transform="translate(0 18.042)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#y" />
          </mask>
          <path
            fill={color}
            d="M5.452 3.274a2.726 2.726 0 1 1-5.452 0 2.726 2.726 0 0 1 5.452 0"
            mask="url(#d)"
          />
        </g>
      </g>
    </svg>
  );
}
